<template>
  <div class="page-askque collect-matchs-detail" v-show="xuanran">
    <div class="tit">发布问题</div>
    <div class="ask-cont">
      <div class="item-wrap">
        <el-input v-model="form.title" placeholder="标题" :maxlength="50" show-word-limit />
      </div>
      <que-rich-text v-if="isReload"
        ref="richtext"
        class="item-wrap"
        v-model="form.content"
        placeholder="问题描述"
      />
      <div class="item-wrap two">
        <div class="two-ite" v-if="form.experience >0 || form.id == 0">
          <span class="left-tit">悬赏</span>
          <el-input v-model="form.experience" disabled v-if="form.experience >0 "/>
          <el-button type="danger" @click="setXSPriceEvent" v-if="form.id == 0">设置金额</el-button>
          <div class="wanfa" @click="wanfaEvent">
            <span>?</span>玩法
          </div>
        </div>
        <div class="two-ite">
          <span class="left-tit"><span>*</span> 标签</span>

          <template v-if="uploadOptions.selectTagsList.length > 0">
            <el-tag type="success"
                    v-for="(item, index) in uploadOptions.selectTagsList"
                    :key="index"
                    effect="dark"
                    size="large"
                    closable @close="handleClose(item)">{{item.tag}}
            </el-tag>
          </template>

          <el-button type="danger" @click="setTagEvent">选择标签</el-button>
        </div>
        <div class="btns" >
          <!--
          publishStatus:0,	//发布状态 (0为未发布；1为发布；)
          auditStatus:0,	//审核状态 (-1为未提交；0为待审核；1为审核通过；2为审核未通过；)
          -->
          <el-button  @click="saveFb" >保 存</el-button>
          <el-button v-if="form.auditStatus !=2 && form.auditStatus !=0 " type="danger" class="fabu" @click="fbEvent">发 布</el-button>
          <el-button type="info" @click="cancelFb">取 消</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      title="设置悬赏金额"
      center
      :visible.sync="xsPriceDia"
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="setting-items">
        <el-button class="item" @click="setPriceVal(1)">1 元</el-button>
        <el-button class="item" @click="setPriceVal(2)">2 元</el-button>
        <el-button class="item" @click="setPriceVal(5)">5 元</el-button>
        <el-button class="item" @click="setPriceVal(10)">10 元</el-button>
        <el-button class="item" @click="setPriceVal(15)">15 元</el-button>
        <el-button class="item" @click="setPriceVal(20)">20 元</el-button>
        <el-input class="item-ipt"
                  placeholder="手动输入"
                  v-model="form.experience"
                  @keyup.native="number($event)"
                  :maxlength="8"
                  show-word-limit>
          <i slot="suffix" class="danw">元</i>
        </el-input>
      </div>
      <span slot="footer" class="setting-items-footer">
        <el-button @click="setPrice(0)">取 消</el-button>
        <el-button type="danger" @click="setPrice(1)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="设置标签"
      :visible.sync="uploadOptions.dialogTags"
      center
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div class="setting-items">
        <el-button
        class="tag-btn"
        v-for="(item, index) in uploadOptions.tagList"
        :type="item.active === false ? '' : 'danger'"
        :key="index"
        @click="selectTagsEvent(index)"
        >
        {{item.tag}}
        </el-button>
        <el-input class="item-ipt" placeholder="请输入新标签" v-model="newTagVal" maxlength="10" show-word-limit>
        <el-button slot="append" @click="addTags()">添加</el-button>

        </el-input>
      </div>
      <span slot="footer" class="setting-items-footer">
        <el-button @click="uploadOptions.dialogTags = false">取 消</el-button>
        <el-button type="danger" @click="selectTagsOver">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="悬赏规则"
      top="65px"
      :visible.sync="dialogVisible"
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
      center
    >
      <wanfa v-if="isReloadWanfa"  :likeCount="likeCount" :disLikeCount="disLikeCount" :disLikeFlag="disLikeFlag" :likeFlag="likeFlag"/>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import vue from 'vue';
import wanfa from '../detail/wanfa'
import queRichText from '../pub/richtext'
import questionApi from '@/api/question'
import tagApi from '@/api/tags'
import qs from 'qs';
import axios from 'axios';
vue.prototype.$axios = axios;

export default {
  components: {
    queRichText,
    wanfa
  },
  data () {
    return {
      xuanran:false, //是否全部渲染完成
      title: '',
      experience: '',
      tag: '',
      tags: [],
      xsPriceDia: false,
      tagDia: false,
      dialogVisible: false,
      isReload: true,
      isReloadWanfa: false,
      form: {
        id:0,
        title:'',			//标题
        supportcnt:0,		// 赞数
        opposecnt:0,		//踩数
        commentto:'',		//评论对象
        time:'',		//创建时间
        userId:0,		//用户ID
        hits:0,			//浏览量
        stick:0,			//是否置顶  (0为否；1为是；)
        comment:0,		//回答数
        status:0,			//是否加精  (0为否；1为是；)
        experience:0,	//悬赏/经验值
        accept:0,		//采纳答案ID
        publishStatus:0,	//发布状态 (0为未发布；1为发布；)
        auditStatus:-1,	//审核状态 (-1为未提交；0为待审核；1为审核通过；2为审核未通过；)
        publishDate:'',		//发布日期
        deleteFlag:-1,		//删除标识 (-1为草稿；0为正常；1为删除；)
        attentionCount:0,	//关注数
        ruleIsUseful:0,	//悬赏规则是否有用 (0为无用；1为有用；)
        content:'',			//内容
        questionTags:'',	//问题标签 ( 以json串形式存储      串形式存储；)
      },
      uploadOptions: {
        title: '',
        desc: '',
        typeVal: '模型',
        typeIndex: 1,
        typeList: [],
        type: 0,
        //form:0,
        parentId:-1,
        tagList: [],
        selectTagsList: [],
        dialogTags: false
      },

      newTagVal:'',
      callbackurl:'',
      disLikeCount:0,
      likeCount:0,
      likeFlag:false,
      disLikeFlag:false,
    }
  },
  mounted () {
    let thiss = this
    let id = thiss.$route.query.id
    //自定义标签
    thiss.uploadOptions.type=1
    thiss.uploadOptions.form=""
    tagApi.getBackList(thiss.uploadOptions).then(re => {

      thiss.uploadOptions.tagList = re.response
      thiss.formLoading = false

      if(id){
        //编辑
        questionApi.select(id).then(re=>{
          if(re.code == 1 && re.response != null){
            thiss.form = re.response
            thiss.xuanran = true
            //标签回填{
            if(thiss.form.questionTags !=null && thiss.form.questionTags !=''  ){
              let selTag =  JSON.parse(thiss.form.questionTags)
              thiss.uploadOptions.tagList.forEach((item, index)  => {
                selTag.forEach(itemTag => {
                  if(item.id ==itemTag.id ){
                    thiss.uploadOptions.tagList[index].active = true
                    thiss.uploadOptions.selectTagsList.push(itemTag);
                  }
                })
                //this_.form.productionTags = ''
              })
            }
            thiss.reLoadTick()
          }else {
            thiss.$message({
              message:'获取问题对象失败',
              type:'error'
            })
          }

        })
      }else{
        //新增，判断是否有草稿
        questionApi.selectDraft(null).then(re =>{
          if(re.code == -1){
            thiss.$message({
              message: re.message,
              type: 'error'
            });
            return false
          }else{
            thiss.xuanran = true
            if(re.response == null){
              //无草稿
              //thiss.initData()
            }else{
              thiss.loadSaved(re.response)
            }
          }


        })
      }



    })

    let url = '/rrbi/question/getTricks?&ti=' + new Date().getMilliseconds();
    this.$axios.get(url).then(re=>{
      if(re.data.code == 1){
        let reData = re.data.response
        this.likeCount = reData.likeCount
        this.disLikeCount = reData.disLikeCount
        this.disLikeFlag = reData.disLikeFlag
        this.likeFlag = reData.likeFlag

        this.reLoadWanfaTick()
      }
    })

    //
  },
  methods: {
    initData(){

    },
    //点击设置金额
    setXSPriceEvent () {
      this.xsPriceDia = true
    },
    //点击选择标签
    setTagEvent () {
      this.uploadOptions.dialogTags = true
    },
    //点击玩法
    wanfaEvent () {
      this.dialogVisible = true
    },
    //确定设置金额
    setPrice (type) {
      if(type == 0){
        this.form.experience =0
      }
      this.xsPriceDia = false
    },
    //选择金额
    setPriceVal(val){
      this.form.experience = val
    },
    //重置组建
    reLoadTick(){
      let thiss = this
      thiss.isReload = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      thiss.$nextTick(() => {
        thiss.isReload = true
      })
    },

    //重置组建
    reLoadWanfaTick(){
      let thiss = this
      thiss.isReloadWanfa = false
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      thiss.$nextTick(() => {
        thiss.isReloadWanfa = true
      })
    },
    //数值正则表达式
    number(e){
      let inputValue = e.target.value
      let len = e.target.value.length
      let flag = new RegExp("^[0-9]([0-9])*$").test(inputValue);
      if(!flag){
        this.$message.error("请输入大于1正整数")
        e.target.value = inputValue.substring(0,len-1);
      }
    },
    //表单验证
    validate(){
      let thiss = this
      if(thiss.form.title.trim() ==''){
        thiss.$message.error('标题不能为空!')
        return false
      }
      if(thiss.form.content.trim() ==''){
        thiss.$message.error('内容不能为空!')
        return false
      }
      if(thiss.uploadOptions.selectTagsList.length ==0){
        thiss.$message.error('标签不能为空!')
        return false
      }
      return true
    },


    addTags(){
      let this_ = this
      let val = this_.newTagVal.trim()
      let isVal = false
      if(val ==''){
        this_.$message.error("标签内容不能为空")
        return false
      }
      let index_ =0
      this_.uploadOptions.tagList.forEach((item,index) => {
        if(val == item.tag ){
          isVal = true
        }
        index_ = index
      })
      //循环判断完成后执行
      if(this_.uploadOptions.tagList.length == (index_ + 1)){
        if(isVal){
          this_.$message.error("标签内容不能重复")
          return false
        }else{
          let postData={
            tag:val
          }
          let url="/rrbi/tags/add-tags?ti="+new Date().getMilliseconds();
          this_.$axios.post(url, qs.stringify(postData)).then(function(result) {
            if (result.data.code == 1) {
              this_.$message({
                message: '添加成功',
                type: 'success'
              });
              let reData = result.data.response
              reData.active = false
              this_.uploadOptions.tagList.push(reData)
              this_.newTagVal =''
            } else {
              this_.$message({
                message: '添加失败',
                type: 'error'
              });
            }
          })
        }
      }


    },

    ////////////////////////////   业务   //////////////////////

    //选取标签
    selectTagsEvent (index) {
      let thiss= this
      let isFlag = thiss.uploadOptions.tagList[index].active
      //如果是要选中(当前非选中状态),判断是否已经选中5个
      if(!isFlag){
        let selNum = 0
        thiss.uploadOptions.tagList.forEach(item => {
          if(item.active){
            selNum++
          }
        })
        if(selNum == 5){
          this.$message.error('标签选中最多5个!')
          return false
        }
      }
      thiss.uploadOptions.tagList[index].active =  !isFlag
    },
    //确认标签
    selectTagsOver () {
      let this_ = this
      this_.uploadOptions.dialogTags = false //隐藏弹框
      this_.uploadOptions.selectTagsList=[]
      this_.uploadOptions.tagList.forEach(item => {
        //console.log("item.active====",item.active)
        if(item.active){
          this_.uploadOptions.selectTagsList.push(item);
        }
      })
      if(this_.uploadOptions.selectTagsList.length >0){
        this_.form.questionTags =  JSON.stringify(this_.uploadOptions.selectTagsList);
      }else{
        this_.form.questionTags=""
      }
    },
    //取消标签
    handleClose(item){
      let this_ = this
      //console.log(item)
      ///取消页面标签
      let delIndex = this_.uploadOptions.selectTagsList.indexOf(item);
      let end = this_.uploadOptions.selectTagsList.splice(delIndex, 1);
      //取消弹窗标签
      this_.uploadOptions.tagList.forEach((itemTag, index)  => {
        if(item.id ==itemTag.id ){
          this_.uploadOptions.tagList[index].active = false
          //this_.uploadOptions.selectTagsList.push(itemTag);
        }
      })
      if(this_.uploadOptions.selectTagsList.length >0){
        this_.form.questionTags =  JSON.stringify(this_.uploadOptions.selectTagsList);
      }else{
        this_.form.questionTags=""
      }
    },

    // 点击保存跳转到列表页
    saveFb () {
      let thiss = this
      //获取子组件值
      thiss.form.content = thiss.$refs.richtext.content

      if(!thiss.validate()){
        return false
      }
      //点击保存，需要判断当前审核状态
      // 1：如果是审核未通过 ，
      // 保存草稿，需要判断 再次判断是否当前有草稿

      questionApi.selectDraft(null).then(re =>{
        if(re.code == -1){
          thiss.$message({
            message: re.message,
            type: 'error'
          });
          return false
        }else{
          if(re.response == null){
            //无草稿
            thiss.doSave()
          }else{
            //判断草稿是否是编辑对象
            if(re.response.id == thiss.form.id){
              //直接保存草稿
             // console.log("判断草稿是否是编辑对象=====直接保存草稿")
              thiss.doSave()
            }else{
              //替换草稿
             // console.log("判断草稿是否是编辑对象=====替换草稿")
              this.changeCG(re.response.id)
            }

          }
        }
      })
    },
    //替换草稿
    changeCG(oldId){
      let thiss =this
      this.$confirm('近期您保存了一个草稿，是否要替换？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // type: 'warning',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        // 删除草稿，保存新草稿
        thiss.form.deleteFlag = 1
        questionApi.delete(oldId).then(deRe =>{
          if(deRe.code == 1){
            thiss.form.id = 0
            thiss.form.deleteFlag = -1
            thiss.doSave()
          }else{
            thiss.$message({
              message: "删除草稿失败",
              type: 'error'
            })
          }
        })
      }).catch(()=>{});//这里是重点！！！
    },
    //更新问题数据
    doSave(){
      let thiss = this
      //如果审核未通过，保存 提交审核
      if(thiss.form.auditStatus == 2){
        thiss.form.auditStatus = 0
      }
      questionApi.update(thiss.form).then(re =>{
        if(re.code == 1){
          this.$router.push({
            path: '/gquestions'
          })
        }
      })

    },
    // 点击发布跳转到详情页
    fbEvent () {
      let thiss = this
      //获取子组件值
      thiss.form.content = thiss.$refs.richtext.content

      if(!thiss.validate()){
        return false
      }

      if(thiss.form.experience == 0){
        //无悬赏发布，直接发布
        thiss.form.auditStatus =1 //审核通过状态
        thiss.form.deleteFlag = 0 //未删除，非草稿 状态
        thiss.form.publishStatus =1 //发布
        thiss.form.publishDate = new Date()
        questionApi.update(thiss.form).then( re => {
          if(re.code == 1){
            this.$router.push({
              path: '/quedetail?id='+re.response.id+'&plate=3'
            })
          }else {
            thiss.$message({
              message:"发布失败",
              type:"error"
            })
          }
        })
      }else{
        //有悬赏发布，保存问题后，跳转支付页面
        thiss.form.auditStatus =-1 //审核通过状态
        thiss.form.deleteFlag = -1 //未删除，非草稿 状态
        thiss.form.ruleIsUseful =1 //悬赏规则有用
        questionApi.update(thiss.form).then(re =>{
          if(re.code == 1){
            thiss.$router.push({
              path:'/questionpay',
              query: {id:re.response.id,plate:3}
            })
          }else {
            thiss.$message({
              message:"保存失败",
              type:"error"
            })
          }
        })

      }
      return false
    },
    // 点击取消跳转到列表页
    cancelFb () {
      this.$confirm('关闭页面之前，是否要将编辑内容保存为草稿？', '', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        this.saveFb()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消保存'
        })
        this.$router.push({
          path: '/gquestions?plate=3'
        })
      })
    },

    loadSaved (item) {
      let thiss = this
      thiss.$confirm('近期您保存了一个草稿，是否要加载？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // type: 'warning',
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        // 加载保存的内容
        //thiss.initData()
        thiss.form = item
        //标签回填{
        if(thiss.form.questionTags !=null && thiss.form.questionTags !=''  ){
          let selTag =  JSON.parse(thiss.form.questionTags)
          thiss.uploadOptions.tagList.forEach((item, index)  => {
            selTag.forEach(itemTag => {
              if(item.id ==itemTag.id ){
                thiss.uploadOptions.tagList[index].active = true
                thiss.uploadOptions.selectTagsList.push(itemTag);
              }
            })
            //this_.form.productionTags = ''
          })
        }
        thiss.reLoadTick()
      }).catch(()=>{});//这里是重点！！！
    },

  }
}
</script>

<style scoped lang="less">
.page-askque{
  padding-top: @NAVHEIGHT;
  .tit{
    margin-top: 20px;
    color: #575757;
    font-size: 16px;
  }
  .ask-cont{
    margin-top: 20px;
    .item-wrap{
      margin-top: 10px;
      background: #fff;
      &.two{
        padding: 20px 10px;
        .two-ite{
          margin-bottom: 20px;
          .left-tit{
            display: inline-block;
            margin-right: 15px;
            width: 50px;
            line-height: 32px;
            text-align: right;
            font-size: 14px;
            span{
              color: #ef4a58;
            }
          }
          .el-input{
            margin-right: 15px;
            width: 100px;
          }
          .el-tag{
            margin-right: 10px;
          }
          .el-button{
            background: #ef4a58;
          }
          .wanfa{
            margin-left: 5px;
            display: inline-block;
            line-height: 32px;
            font-size: 12px;
            cursor: pointer;
            span{
              display: inline-block;
              margin-right: 4px;
              width: 20px;
              height: 20px;
              line-height: 20px;
              text-align: center;
              color: #8f8f8f;
              font-size: 14px;
              background: #f2f2f2;
              border-radius: 50%;
            }
          }
        }
        .btns{
          text-align: right;
          .fabu{
            background: #ef4a58;;
          }
        }
      }
    }
  }
  .setting-items{
    .item{
      margin-bottom: 5px;
      min-width: 60px;
      &.el-button--danger{
        background: #ef4a58;
      }
    }
    .item-ipt{
      margin-left: 10px;
      margin-bottom: 5px;
      width: 150px;
      .danw{
        line-height: 32px;
        font-style: normal;
      }
    }
  }
  .setting-items-footer{
    .el-button--danger{
      background: #ef4a58;
    }
  }
}
@media screen and (max-width: 750px){
  .page-askque{
    padding: 0 10px;
    .ask-cont{
      .item-wrap.two{
        .two-ite{
          display: flex;
          padding: 0 10px;
          .el-input{
            margin: 0 10px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1100px){
  .collect-matchs-detail {
    width: 900px;
  }
}
</style>
